import React, { Fragment, useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import { useDispatch, useSelector } from 'react-redux';

import { editarBreadcrumb } from '../../../actions/breadcrumb';
import { buscarAsesoresConfiguracion } from '../../../actions/configuracion';

import AdministrarHorarios from './AdministrarHorarios';

const Asesores = () => {

    let rutasBread = [
        {
            activo: true,
            nombre: 'Asesores',
            path: '/configuracion/asesores'
        }
    ];

    const dispatch =  useDispatch();

    const { listado } = useSelector(state => state.configuracion.asesores);

    const [asesores, setAsesores] = useState([]);

    const [asesorAdministrar, setAsesorAdministrar] = useState(null);

    const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' };

    const columns = [
        {
            name: 'Nombre',
            sortable: true, 
            selector: row => [row.nombre, row.apellido_paterno, row.apellido_materno].join(' ')
        },
        {
            name: 'Tipo',
            sortable: true, 
            selector: row => row.tipo
        },
        {
            name: 'Intervalo de cita',
            sortable: true, 
            selector: row => intervaloToText(row.intervalo_cita)
        },
        {
            name: 'Lunes',
            sortable: true, 
            cell: item => `${item.horarios[1] ? horariosToText(item.horarios[1]) : '-'}`
        },
        {
            name: 'Martes',
            sortable: true, 
            cell: item => `${item.horarios[2] ? horariosToText(item.horarios[2]) : '-'}`
        },
        {
            name: 'Miercoles',
            sortable: true, 
            cell: item => `${item.horarios[3] ? horariosToText(item.horarios[3]) : '-'}`
        },
        {
            name: 'Jueves',
            sortable: true, 
            cell: item => `${item.horarios[4] ? horariosToText(item.horarios[4]) : '-'}`
        },
        {
            name: 'Viernes',
            sortable: true, 
            cell: item => `${item.horarios[5] ? horariosToText(item.horarios[5]) : '-'}`
        },
        {
            name: 'Sabado',
            sortable: true, 
            cell: item => `${item.horarios[6] ? horariosToText(item.horarios[6]) : '-'}`
        },
        {
            name: 'Domingo',
            sortable: true, 
            cell: item => `${item.horarios[0] ? horariosToText(item.horarios[0]) : '-'}`
        },
        {
            name: '',
            cell: row => {
                if(row._id){
                    return(
                        <div className="text-right w-100">
                            <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleAdministrarAsesor(row)}><i className="fas fa-edit text-warning"></i></button>
                        </div>
                    )
                }else{
                    return(<></>)
                }
            }
        }
    ];

    /* Administrar asesor */
    const handleAdministrarAsesor = (asesor) => {
        setAsesorAdministrar(asesor);
    }

    /* Funciones generales */
    const horariosToText = (horarios) => {
        let horarios_formateados = [];

        for (let i = 0; i < horarios.length; i++) {
            horarios_formateados.push(horarios[i].hora_inicio + ' - ' + horarios[i].hora_fin);
        }

        return horarios_formateados.join(', ');
    }

    const intervaloToText = (intervalo) => {
        let intervalo_texto = '';

        switch(intervalo){
            case 15:
                intervalo_texto = '15 minutos';
                break;

            case 30:
                intervalo_texto = '30 minutos';
                break;

            case 60:
                intervalo_texto = '1 hora';
                break;

            case 90:
                intervalo_texto = '1 hora y media';
                break;

            case 120:
                intervalo_texto = '2 horas';
                break;

            default:
                intervalo_texto = 'Sin definir';
                break;
        }

        return intervalo_texto;
    }

    useEffect(() => {
        dispatch(buscarAsesoresConfiguracion());
    }, []);

    useEffect(() => {
        setAsesores(listado);
    }, [listado]);

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);

    return (
        <Fragment>

            <AdministrarHorarios asesor={asesorAdministrar} reestablecerAsesor={handleAdministrarAsesor} />

            <div className="row">
                <div className="col-md-10 offset-md-1 pb-4">
                    <h3 className="mb-3 mt-5">Asesores</h3>

                    <div className="mt-2">
                        <DataTable 
                            columns={columns}
                            data={asesores}
                            pagination
                            paginationPerPage={20}
                            paginationRowsPerPageOptions={[5, 10, 20, 50]}
                            paginationComponentOptions={paginationOptions}
                            highlightOnHover={true}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default Asesores;